import fetch from "isomorphic-fetch"
import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client"
import { useStore } from "react-redux"

const getApiKey = async () => {
  const data = await (await fetch("https://euwpsub0smazf02.azurewebsites.net/api/api")).json()
  return data.apiKey
}

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: "https://prod.p.api.ey.com/cda/v1", //new Production url
    fetch: async (uri, options) => {
      const store = useStore()
      const msalToken = store.getState().users.users[2]
      options.headers.Authorization = `${msalToken}`
      options.headers.apiKey = await getApiKey()
      return fetch(uri, options)
    },
  }),
})
export default client
